import React from 'react';
import "./Center.scss";

export default function Center({ onFetchData, onClickAnno1,minLvl,maxLvl, annoImage, hatImage, amuImage, cloakImage, swordImage, anno2Image, beltImage, bootsImage,onItemSelected, onHatSelected, onAmuSelected, onCloakSelected, onSwordSelected,onAnno2Selected,onBeltSelected,onBootsSelected}) {
  console.log("test center", annoImage);

  const images = {
    perso: require("./../../../Asset/Stuff/perso.png"),
    annobg1: require('./../../../Asset/Stuff/annobg1.png'),
    annobg2: require('./../../../Asset/Stuff/annobg2.png'),
    coifbg: require('./../../../Asset/Stuff/coifbg.png'),
    capebg: require('./../../../Asset/Stuff/capebg.png'),
    bottesbg: require('./../../../Asset/Stuff/bottesbg.png'),
    ceinturebg: require('./../../../Asset/Stuff/ceinturebg.png'),
    amubg: require('./../../../Asset/Stuff/amubg.png'),
    cacbg: require('./../../../Asset/Stuff/cacbg.png'),
  };


  const handleButtonClick = (itemType) => {
    onFetchData(minLvl, maxLvl, itemType);
    onClickAnno1();
    if (itemType === "hat") {
      onHatSelected();
    }
    else if (itemType === "amulet") {
      onAmuSelected();
    }
    else if (itemType === "cloak") {
      onCloakSelected();
    }
    else if (itemType === "sword") {
      onSwordSelected();
    }
    else if (itemType === "ring") {
    if (annoImage) {
      onAnno2Selected();
    } else {
      onItemSelected();
    }
    } else if (itemType === "belt") {
      onBeltSelected();
    }
    else if (itemType === "boots") {
      onBootsSelected();
    }
  };
  
  const handleRemoveAnnoImage  = () => {
      onItemSelected(null);
  };
  const handleRemoveAnno2Image = () => {
      onAnno2Selected(null);
  };
  const handleRemoveHatImage = () => {
      onHatSelected(null);
  };
  const handleRemoveAmuImage = () => {
      onAmuSelected(null);
  };
  const handleRemoveCloakmage = () => {
      onCloakSelected(null);
  };
  const handleRemoveSwordImage = () => {
      onSwordSelected(null);
  };
  const handleRemoveBeltImage = () => {
      onBeltSelected(null);
  };
  const handleRemoveBootsImage = () => {
      onBootsSelected(null);
  };

  return (
    <div className='center__wrapper'>
      <div className="center__box">
        <img className='avatar' src={images.perso} alt="" />
        <div className="item__btn__wrapper">
          <div onClick={() => handleButtonClick("hat")}  className='item__btn item__btn__coif'>
            {!hatImage ? (
              <img className='item__bg' src={images.coifbg} alt="" />
            ) : (
              <>
                <img className='anno__selected' src={hatImage.image_urls.hd} alt="" />
                {hatImage && (
                  <div onClick={handleRemoveHatImage} className='close__img'>
                    <div className="white__bar"></div>
                  </div>
                )}
                {hatImage && (
                  <div className="hat__selected__info hover__selected__info">
                    <h4 className='item__name'>{hatImage.name}</h4>
                    <span className='item__lvl'>Lvl {hatImage.level}</span>
                    <div className="item__content">
                      {hatImage.effects &&
                        Array.isArray(hatImage.effects) &&
                        hatImage.effects.map((effect, effectIndex) => (
                          <div className="item__solo" key={effectIndex}>
                            <span>{effect.formatted}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div onClick={() => handleButtonClick("amulet")} className='item__btn item__btn__amu'>
            {!amuImage ? (
              <img className='item__bg' src={images.amubg} alt="" />
            ) : (
              <>
                <img className='anno__selected' src={amuImage.image_urls.hd} alt="" />
                {amuImage && (
                  <div onClick={handleRemoveAmuImage} className='close__img'>
                    <div className="white__bar"></div>
                  </div>
                )}
                {amuImage && (
                  <div className="amu__selected__info hover__selected__info">
                    <h4 className='item__name'>{amuImage.name}</h4>
                    <span className='item__lvl'>Lvl {amuImage.level}</span>
                    <div className="item__content">
                      {amuImage.effects &&
                        Array.isArray(amuImage.effects) &&
                        amuImage.effects.map((effect, effectIndex) => (
                          <div className="item__solo" key={effectIndex}>
                            <span>{effect.formatted}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div onClick={() => handleButtonClick("cloak")} className='item__btn item__btn__cape'>
            {!cloakImage ? (
              <img className='item__bg' src={images.capebg} alt="" />
            ) : (
              <>
                <img className='anno__selected' src={cloakImage.image_urls.hd} alt="" />
                {cloakImage && (
                  <div onClick={handleRemoveCloakmage} className='close__img'>
                    <div className="white__bar"></div>
                  </div>
                )}
                {cloakImage && (
                  <div className="cloak__selected__info hover__selected__info">
                    <h4 className='item__name'>{cloakImage.name}</h4>
                    <span className='item__lvl'>Lvl {cloakImage.level}</span>
                    <div className="item__content">
                      {cloakImage.effects &&
                        Array.isArray(cloakImage.effects) &&
                        cloakImage.effects.map((effect, effectIndex) => (
                          <div className="item__solo" key={effectIndex}>
                            <span>{effect.formatted}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div onClick={() => handleButtonClick("sword")} className='item__btn item__btn__cac'>
            {!swordImage ? (
              <img className='item__bg' src={images.cacbg} alt="" />
            ) : (
              <>
                <img className='anno__selected' src={swordImage.image_urls.hd} alt="" />
                {swordImage && (
                  <div onClick={handleRemoveSwordImage} className='close__img'>
                    <div className="white__bar"></div>
                  </div>
                )}
                {swordImage && (
                  <div className="sword__selected__info hover__selected__info">
                    <h4 className='item__name'>{swordImage.name}</h4>
                    <span className='item__lvl'>Lvl {swordImage.level}</span>
                    <div className="item__content">
                      {swordImage.effects &&
                        Array.isArray(swordImage.effects) &&
                        swordImage.effects.map((effect, effectIndex) => (
                          <div className="item__solo" key={effectIndex}>
                            <span>{effect.formatted}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div onClick={() => handleButtonClick("ring")} className='item__btn item__btn__anno1'>
            {!annoImage ? (
              <img className='item__bg' src={images.annobg1} alt="" />
            ) : (
              <>
                <img className='anno__selected' src={annoImage.image_urls.hd} alt="" />
                {annoImage && (
                  <div onClick={handleRemoveAnnoImage} className='close__img'>
                    <div className="white__bar"></div>
                  </div>
                )}
                {annoImage && (
                  <div className="anno__selected__info hover__selected__info">
                    <h4 className='item__name'>{annoImage.name}</h4>
                    <span className='item__lvl'>Lvl {annoImage.level}</span>
                    <div className="item__content">
                      {annoImage.effects &&
                        Array.isArray(annoImage.effects) &&
                        annoImage.effects.map((effect, effectIndex) => (
                          <div className="item__solo" key={effectIndex}>
                            <span>{effect.formatted}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div onClick={() => handleButtonClick("ring")} className='item__btn item__btn__anno2'>
            {!anno2Image ? (
              <img className='item__bg' src={images.annobg2} alt="" />
            ) : (
              <>
                <img className='anno__selected' src={anno2Image.image_urls.hd} alt="" />
                {anno2Image && (
                  <div onClick={handleRemoveAnno2Image} className='close__img'>
                    <div className="white__bar"></div>
                  </div>
                )}
                {anno2Image && (
                  <div className="anno2__selected__info hover__selected__info">
                    <h4 className='item__name'>{anno2Image.name}</h4>
                    <span className='item__lvl'>Lvl {anno2Image.level}</span>
                    <div className="item__content">
                      {anno2Image.effects &&
                        Array.isArray(anno2Image.effects) &&
                        anno2Image.effects.map((effect, effectIndex) => (
                          <div className="item__solo" key={effectIndex}>
                            <span>{effect.formatted}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div onClick={() => handleButtonClick("belt")} className='item__btn item__btn__ceinture'>
            {!beltImage ? (
              <img className='item__bg' src={images.ceinturebg} alt="" />
            ) : (
              <>
                <img className='anno__selected' src={beltImage.image_urls.hd} alt="" />
                {beltImage && (
                  <div onClick={handleRemoveBeltImage} className='close__img'>
                    <div className="white__bar"></div>
                  </div>
                )}
                {beltImage && (
                  <div className="belt__selected__info hover__selected__info">
                    <h4 className='item__name'>{beltImage.name}</h4>
                    <span className='item__lvl'>Lvl {beltImage.level}</span>
                    <div className="item__content">
                      {beltImage.effects &&
                        Array.isArray(beltImage.effects) &&
                        beltImage.effects.map((effect, effectIndex) => (
                          <div className="item__solo" key={effectIndex}>
                            <span>{effect.formatted}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div onClick={() => handleButtonClick("boots")} className='item__btn item__btn__botte'>
            {!bootsImage ? (
              <img className='item__bg' src={images.bottesbg} alt="" />
            ) : (
              <>
                <img className='anno__selected' src={bootsImage.image_urls.hd} alt="" />
                {bootsImage && (
                  <div onClick={handleRemoveBootsImage} className='close__img'>
                    <div className="white__bar"></div>
                  </div>
                )}
                {bootsImage && (
                  <div className="boots__selected__info hover__selected__info">
                    <h4 className='item__name'>{bootsImage.name}</h4>
                    <span className='item__lvl'>Lvl {bootsImage.level}</span>
                    <div className="item__content">
                      {bootsImage.effects &&
                        Array.isArray(bootsImage.effects) &&
                        bootsImage.effects.map((effect, effectIndex) => (
                          <div className="item__solo" key={effectIndex}>
                            <span>{effect.formatted}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
